import { componentStyles, useColors } from "@mallardbay/lib-react-components"
import { SIZES } from "@mallardbay/lib-shared-helpers"

import { CHAT_ATTACHMENT_CHIP_BORDER_RADIUS } from "~components/shared/chat/chat-attachment-preview-constants"

export default function useChatAttachmentChipStyles() {
    const colors = useColors()

    return componentStyles({
        chip: {
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            borderRadius: CHAT_ATTACHMENT_CHIP_BORDER_RADIUS,
            backgroundColor: colors.bgTertiary,
            paddingX: 1.5,
            paddingY: 0.5,
            maxWidth: "100%",
        },
        filename: {
            fontSize: SIZES.XS,
            color: colors.secondaryText,
            maxWidth: 120,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        fileLink: {
            fontSize: SIZES.XS,
            color: colors.secondaryText,
        },
    })
}
